var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe06(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "3 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.68675 15.6451L7.59494 14.5435C7.6983 14.4839 7.8196 14.4631 7.9369 14.4851L11.6914 15.1878C12 15.2455 12.2848 15.008 12.2834 14.6941L12.2688 11.4045C12.2684 11.3151 12.2919 11.2272 12.337 11.15L14.2317 7.90621C14.3303 7.73739 14.3215 7.52658 14.2091 7.3666L11.0189 2.82568M22.0002 4.85905C16.5002 7.50004 19.5 11 20.5002 11.5C22.3773 12.4384 24.9876 12.5 24.9876 12.5C24.9958 12.3344 25 12.1677 25 12C25 6.47715 20.5228 2 15 2C9.47715 2 5 6.47715 5 12C5 17.5228 9.47715 22 15 22C15.1677 22 15.3344 21.9959 15.5 21.9877M19.7578 21.9398L16.591 13.591L24.9398 16.7578L21.2376 18.2376L19.7578 21.9398Z",
    stroke: "#A2BBBF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe06);
export default __webpack_public_path__ + "static/media/globe-06.fcac3c2ddfed1f9eead1f8f2f353ed49.svg";
export { ForwardRef as ReactComponent };